<template>
  <div class="chat-item">
    <!-- 用户发言 -->
    <div class="user" v-if="chatItme.type === 1">
      <div class="user-info-box">
        <div class="msgbox">
          {{ chatItme.msg }}
          <div class="triangle"></div>
        </div>
        <div class="imgbox">
          <img src="img/studentIcon.png" alt="">
        </div>
      </div>
    </div>
    <!-- 问答与服务 -->
    <div class="system" v-if="chatItme.type === 2">
      <div class="title">请<span>选择</span>您想继续了解的相关问题</div>
      <div class="container">
        <ul>
          <li
            v-for="(item, index) in chatItme.resultList"
            :key="index"
            @click="toDetails(item)"
          >{{ item.num }}、<span v-if="item.type === 1">进入</span>{{"<" + item.name + ">" }}</li>
        </ul>
      </div>
    </div>
    <!-- 无法理解提问 resultList长度为 0 -->
    <div class="system" v-if="chatItme.type === 3">
       <div class="title">{{ chatItme.noResultMsg }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    chatItme: {
      type: Object,
    },
  },
  methods: {
    toDetails(item) {
      this.$emit('toDetails', item)
    }
  }
}
</script>

<style lang="scss">
.chat-item {
  margin: 15px 0;
  .user {
    width: 100%;
    overflow: hidden;
    &-info-box {
      width: 100%;
      float: right;
      display: flex;
      align-items: flex-start;
      justify-content: flex-end;
      .msgbox {
        max-width: calc(100% - 45px - 40px - 40px);
        position: relative;
        border-radius: 5px;
        padding: 10px;
        margin-right: 20px;
        font-size: 13px;
        background: #40A9FF;
        color: #ffffff;
        line-height: 20px;
        word-wrap: break-word;
        // white-space: pre-wrap;
        .triangle {
          position: absolute;
          right: -5px;
          top: 7px;
          width: 0px;
          height: 0px;
          background: #40A9FF;
          border-top: 5px solid #F6F6F6;
          border-right: 0px;
          border-bottom: 5px solid #F6F6F6;
          border-left: 5px solid #40A9FF;
        }
      }
      .imgbox {
        overflow: hidden;
        width: 45px;
        height: 45px;
        border-radius: 50%;
        text-align: center;
        img {
          width: 100%;
        }
      }
    }
  }
  .system {
    width: calc(100% - 30px);
    background: #ffffff;
    margin: 10px 0;
    border-radius: 5px;
    padding: 0 15px;
    .title {
      padding: 10px 0;
      font-size: 13px;
      font-weight: bold;
      span {
        color:#FF4D4F;
        font-weight: bold;
      }
    }
    .container {
      font-size: 12px;
      padding: 10px;
      ul {
        li {
          margin-bottom: 5px;
          padding: 0 5px;
          height: 35px;
          line-height: 35px;
          border: 1px solid #EFEFF4;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}
</style>